/**
 * @generated SignedSource<<a6643ca16e752f81d2e28b38142b016f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetEmployeeLeaveSettingsLeaveReasonsQuery$variables = Record<PropertyKey, never>;
export type WidgetEmployeeLeaveSettingsLeaveReasonsQuery$data = {
  readonly store: {
    readonly id: string;
    readonly leaveReasons: ReadonlyArray<{
      readonly id: string;
      readonly leaveReason: string;
    }>;
  };
};
export type WidgetEmployeeLeaveSettingsLeaveReasonsQuery = {
  response: WidgetEmployeeLeaveSettingsLeaveReasonsQuery$data;
  variables: WidgetEmployeeLeaveSettingsLeaveReasonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "LeaveReason",
        "kind": "LinkedField",
        "name": "leaveReasons",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "leaveReason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetEmployeeLeaveSettingsLeaveReasonsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WidgetEmployeeLeaveSettingsLeaveReasonsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0b31f58554c4e0f314ee817974753564",
    "id": null,
    "metadata": {},
    "name": "WidgetEmployeeLeaveSettingsLeaveReasonsQuery",
    "operationKind": "query",
    "text": "query WidgetEmployeeLeaveSettingsLeaveReasonsQuery {\n  store {\n    id\n    leaveReasons {\n      id\n      leaveReason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "45fff5c14670c4ff55fe85f99e11c63d";

export default node;
